<template>
  <DashboardStatCard
    title="Outstanding"
    subtitle="Customer balance"
    icon="mdi-cash-clock"
    color="orange"
    :loading="isLoading"
    to="/customer/list"
  >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">{{ compactCurrency(amount) }}</span>
      </template>
      <span>{{ fullCurrency(amount) }}</span>
    </v-tooltip>
  </DashboardStatCard>
</template>

<script>
import customerService from "../../service";
import DashboardStatCard from "@/modules/Home/components/DashboardStatCard";

export default {
  components: {
    DashboardStatCard,
  },

  data() {
    return {
      isLoading: true,
      amount: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    compactCurrency(value) {
      const amount = Number(value || 0);
      const absolute = Math.abs(amount);
      let divisor = 1;
      let suffix = "";

      if (absolute >= 1000000) {
        divisor = 1000000;
        suffix = "M";
      } else if (absolute >= 1000) {
        divisor = 1000;
        suffix = "K";
      }

      const compact = amount / divisor;
      const digits = suffix ? 1 : 2;
      return `$${compact.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      })}${suffix}`;
    },

    fullCurrency(value) {
      return Number(value || 0).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    loadData() {
      customerService.getOutstandingBalance().then((response) => {
        this.amount = response.data;
        this.isLoading = false;
      });
    },
  },
};
</script>
